import React from 'react';
import NTPLogo from 'ntp-logo-react';

export const Netopia = () => {
    return (
        <div className={'flex flex-row justify-center items-center w-full'}>
            <NTPLogo color="#ffffff" version="horizontal" secret="102503" />
        </div>
    );
};